<template>
<div class="microPage">
    <div class="minPageTips">微页面支持同步应用于店铺和小程序，点击“设为主页”可将页面设为店铺和小程序主页。 <span>了解更多</span></div>
    <div class="homepageBox">
        <img src="../../../../common/images/shop/shop-icon.png" alt="">
        <div class="rightText">
            <div class="shopNameBox">
                <div class="shopName">
                    <span class="home">主页</span>
                    <span class="shopHome">店铺主页</span>
                </div>
                <div class="action btn-operate-list">
                    <el-button @click="handleEdit(item)" type="text" size="small">编辑</el-button>
                    <span class="line">|</span>
                    <el-popover trigger="click" placement="top" width="320">
                        <div class="microPage-pr-code-upload padding-20">
                            <img :src="item.qrShare">
                            <div class="pr-code-text cursor" @click="download(item.qrShare, item.subject)">下载二维码</div>
                            <div class="btn-operate">
                                <el-input v-model="item.shareurl" class="condition"></el-input>
                                <el-button  type="primary" size="mini" v-clipboard:copy="item.share" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                        </div>
                        <el-button slot="reference" type="text" size="small">分享</el-button>
                    </el-popover>
                </div>
            </div>
            <div class="time">
                创建时间：<span>{{item.datetime}}</span>
            </div>
        </div>
    </div>
    <div class="actionBox">
        <el-button type="primary" @click="handleAdd">新建微页面</el-button>
        <div class="search">
            <el-input placeholder="输入页面名称" v-model="param.pagename"></el-input>
            <el-button @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="pageList">
        <div class="listTitle">微页面列表(<span>{{tableData.length}}</span>条)</div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="pagename" label="页面名称" class-name="pageNameBox">
                    <template slot-scope="scope">
                        <div class="pageName">
                            <div class="homePage">
                                <div class="name">
                                    {{scope.row.pagename}}
                                </div>
                                <div class="pageTips" v-if="scope.row.isdefault">店铺主页</div>
                            </div>
                            <!-- <div class="commonPage">
                                {{scope.row.pagename}}
                            </div> -->
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="创建时间" class-name="createTime"></el-table-column>
                <el-table-column prop="address" label="操作" class-name="operation">
                    <template slot-scope="scope">
                        <div class="action">
                            <div class="homepageAction">
                                <span>
                                    <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                                    <span class="line">|</span>
                                </span>
                                <span v-if="!scope.row.isdefault">
                                    <el-button @click="handleDefault(scope.row)" type="text" size="small">设为主页</el-button>
                                    <span class="line">|</span>
                                </span>
                                <span>
                                    <Share :row='scope.row'></Share>
                                </span>
                                <span>
                                    <el-button @click="handleCopy(scope.row)" type="text" size="small">复制页面</el-button>
                                </span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <page :total='total' @getList="_getlist" ref="page"></page>
</div>
</template>
<script>
import Page from '@/base/page/page'
import {getMicroPageList, editMicroPageDefault, copyMicroPage} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import {urlToQRCode, downloadImage} from 'common/js/tools'
import Share from '@/base/share/share'
export default {
    name: 'microPage',
    data() {
        return {
            total: 20,
            tableData: [],
            item: {},
            param: {
                pagename: ''
            }
        }
    },
    mounted() {
        this._getlist()
    },
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            this.$router.push({name: 'MicroPageEdit'})
        },
        handleEdit(row) {
            this.$router.push({name: 'MicroPageEdit', query: {id: row.innerid}})
        },
        handleCopy(row) {
            copyMicroPage({
                data: {
                    innerid: row.innerid
                },
                success: data => {
                    this.$message.success('设置店铺主页成功！')
                    this.setLoading(false)
                    this._getlist()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
            console.log(e.text)
        },
        onError(e) {
            alert('失败')
        },
        handleDefault(row) {
            editMicroPageDefault({
                data: {
                    innerid: row.innerid
                },
                success: data => {
                    this.$message.success('设置店铺主页成功！')
                    this.setLoading(false)
                    this._getlist()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getlist() {
            getMicroPageList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.tableData.forEach(obj => {
                        if (obj.isdefault) {
                            this.item = obj
                        }
                        this.tableData.forEach(obj => {
                            obj.qrShare = urlToQRCode(obj.shareurl)
                        })
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'page',
            'permission'
        ])
    },
    components: {
        Page,
        Share
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
@import "~common/scss/mixin";
.microPage{
    .minPageTips{
        height: 50px;
        background: #F5F7FA;
        text-indent: 21px;
        line-height: 50px;
        font-size: 14px;
        span{
            color: #409EFF;
        }
    }
    .homepageBox{
        height: 72px;
        background: #F5F7FA;
        margin-top: 20px;
        padding-left: 28px;
        @include flexBox('');
        img{
            width: 48px;
            height: 48px;
            margin-right: 14px;
        }
        .rightText{
            flex: 1;
            .shopNameBox{
                @include flexBox(space-between);
                .shopName{
                    .shopHome{
                        background: #409EFF;
                        color: #fff;
                        display: inline-block;
                        width: 56px;
                        height: 18px;
                        text-align: center;
                        line-height: 18px;
                        margin-left: 10px;
                    }
                }
                .action{
                    padding-right: 30px;
                    color: #409EFF;
                    span:not(.line){
                        cursor: pointer;
                    }
                    .line{
                        margin: 0 10px;
                        position: relative;
                        top: -1px;
                        // cursor: none;
                    }
                }
            }
            .time{
                margin-top: 5px;
            }
        }
    }
    .actionBox{
        margin-top: 20px;
        @include flexBox(space-between);
        .search{
            .el-input{
                width: 240px;
            }
            .el-button{
                margin-left: 20px;
            }
        }
    }
    .pageList{
        margin-top: 20px;
        .el-table{
            margin-top: 11px;
            .pageNameBox{
                padding-left: 30px;
            }
            .pageName{
                .homePage{
                    @include flexBox('');
                    .pageTips{
                        background: #409EFF;
                        color: #fff;
                        width: 56px;
                        height: 18px;
                        line-height: 18px;
                        margin-left: 10px;
                        font-size: 12px;
                        text-align: center;
                    }
                }
            }
            .createTime{
                text-align: center;
            }
            .operation{
                text-align: right;
                .action{
                    color: #409EFF;
                    .homepageAction,.commonPageAction{
                        .line{
                            margin: 5px;
                            position: relative;
                            top: -1px;
                        }
                        span:not(.line){
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}
.el-popover{
    .microPage-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
</style>
